<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NdExtendHandleMenu',
  data () {
    return {
      brand: {},
      store: {},
      storeMap: [
        'StoreMenu',
        'StoreMenuAdjustCreate',
        'StoreMenuAdjust',
        'StoreMenuBindingPos',
        'StoreMenuBuildCreate',
        'StoreMenuBlockCreate',
        'StoreMenuBlock',
        'StoreMenuBuild',
        'StoreMenuCategoryCreate',
        'StoreMenuCategory',
        'StoreMenuEdite',
        'StoreMenuEditeUpJoin',
        'StoreMenuInfo',
        'StoreMenuImage',
        'StoreMenuOptionCreate',
        'StoreMenuOption',
        'StoreMenuPackageCreate',
        'StoreMenuPackage',
        'StoreMenuProductCreate',
        'StoreMenuProduct',
        'StoreMenuScheduleCreate',
        'StoreMenuScheduleEditG',
        'StoreMenuScheduleEditS',
        'StoreMenuSchedule',
        'StoreMenuSetting',
        'StoreMenuStep'
      ]
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    base () {
      let type = ''
      if (this.isStore) {
        type = 'store/'
      } else {
        type = 'brand/'
      }
      return type
    },
    goBackInfo () {
      let name = ''
      let params = {}
      let query = {}
      let title = ''
      let subtitle = ''
      if (this.isStore && this.getRoleType !== 10) {
        switch (this.$route.name) {
          case 'StoreMenu':
            name = 'menuDetailTable'
            title = '菜單管理'
            query.name = this.brand.name
            break
          case 'StoreMenuBuild':
          case 'StoreMenuBuildCreate':
          case 'StoreMenuImage':
          case 'StoreMenuSchedule':
          case 'StoreMenuSetting':
          case 'StoreMenuStep':
            name = 'StoreMenu'
            params.brand_id = this.$route.params.brand_id
            title = '菜單管理'
            break
          case 'StoreMenuAdjust':
          case 'StoreMenuBindingPos':
          case 'StoreMenuBlock':
          case 'StoreMenuCategory':
          case 'StoreMenuOption':
          case 'StoreMenuPackage':
          case 'StoreMenuProduct':
            name = 'StoreMenuStep'
            params.brand_id = this.$route.params.brand_id
            params.store_id = this.$route.params.store_id
            title = '配料庫'
            break
          case 'StoreMenuEdsite':
          case 'StoreMenuInfo':
            name = 'StoreMenuBuild'
            params.brand_id = this.$route.params.brand_id
            params.store_id = this.$route.params.store_id
            title = '菜單建置'
            break
          default:
            console.log('default | 門市')
            break
        }
      } else {
        switch (this.$route.name) {
          case 'BindingPos':
          case 'upAdjust':
          case 'upBlock':
          case 'upCategory':
          case 'upOption':
          case 'upPackage':
          case 'upProduct':
            name = 'brandMenu'
            title = '配料庫'
            break
          case 'ProductSetting':
            name = 'storeTableProductSetting'
            title = '門市列表'
            break
          case 'ProductImage':
            name = 'storeTableProductImage'
            title = '門市列表'
            break
          case 'brandMenu':
          case 'brandMenuTable':
          case 'brandScheduleTable':
          case 'storeTableProductImage':
          case 'storeTableProductSetting':
          case 'cupDiscountTable':
            name = 'menuDetailTable'
            title = '品牌菜單管理'
            query.name = this.brand.name
            break
          case 'crMenu':
          case 'upMenu':
          case 'menuInfo':
            name = 'brandMenuTable'
            title = '菜單建置'
            query.name = this.brand.name
            break
          default:
            console.log('default | 品牌')
            break
        }
      }
      return {
        name,
        params,
        query,
        title,
        subtitle
      }
    },
    /**
     * 相容性模組 ID 注意事項
     * 使用 Store 權限登入，brand_id 就是 store_id
     */
    id () {
      return this.isStore
        ? this.getRoleType === 10
          ? this.$route.params.brand_id
          : this.$route.params.store_id
        : this.$route.params.brand_id
    },
    isStore () {
      let temp = false
      temp = this.getRoleType === 10 || this.storeMap.indexOf(this.$route.name) !== -1
      return temp
    }
  },
  methods: {
    getExtendHandleBrandInfo () {
      console.log('getExtendHandleBrandInfo')
      if (!this.$route.params.brand_id) {
        console.log('params brand_id is null, cant get brand info.')
        return
      }
      return new Promise((resolve) => {
        const url = `/brand/${this.$route.params.brand_id}`
        this.getDataH('get', url, null, (res) => {
          this.brand = res.data.brand_info
          resolve()
        })
      })
    },
    async getExtendHandleMenuInfo () {
      if (this.getRoleType === 10) { // 使用 Store 權限，不用執行 getExtendHandleBrandInfo、getExtendHandleStoreInfo
        return
      }
      await this.getExtendHandleBrandInfo()
      this.getExtendHandleStoreInfo()
    },
    getExtendHandleStoreInfo () {
      if (!this.isStore) return
      if (!this.$route.params.store_id) {
        console.log('params store_id is null, cant get store info.')
        return
      }
      return new Promise((resolve) => {
        const url = `/store/${this.$route.params.store_id}/info`
        this.getDataH('get', url, null, (res) => {
          this.store = res.data.info
          resolve()
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// nd-extend-handle-menu.vue?6333155e